import React, { PropsWithChildren } from 'react';
import useSiteState from '@app/state/SiteState';
import SecurityHelper from '@util/SecurityHelper';
import Authority from '@app/model/authentication/Authority';
import ACLAuthority from '@app/model/profile/ACLAuthority';
import { useSelectedCompanyHotel } from '@app/site/secured/provider/useSelectedCompanyHotel';

interface Props {
    hasAnyAuthority: Authority[]
    hasAclAuthority?: ACLAuthority
}

const SecuredFragment: React.FunctionComponent<PropsWithChildren<Props>> = ({
                                                                                children,
                                                                                hasAnyAuthority,
                                                                                hasAclAuthority
                                                                            }) => {
    const siteState = useSiteState(state => ({principal: state.principal}));
    const companyHotel = useSelectedCompanyHotel();

    return (
        <React.Fragment>
            {!hasAclAuthority && SecurityHelper.hasAnyAuthority(siteState.principal, hasAnyAuthority) && <React.Fragment>{children}</React.Fragment>}
            {!!hasAclAuthority && (SecurityHelper.hasAnyAuthority(siteState.principal, hasAnyAuthority) || SecurityHelper.hasAclAuthority(siteState.principal, companyHotel, hasAclAuthority)) && <React.Fragment>{children}</React.Fragment>}
        </React.Fragment>
    );

};

export default SecuredFragment;
